import { formatCategory } from '../../utils/formatCategory';

/** Flatten grouped values and deduplicate case variants without merging different spellings. */
export const normalizeCategoryFilters = (values: readonly string[]): string[] =>
  Array.from(
    new Set(
      values
        .flatMap(value => value.split(','))
        .filter(Boolean)
        .map(value => (value === 'all' ? value : value.toUpperCase())),
    ),
  );

/** Resolve a selected label to all of its stored spellings, including restored URL filters. */
export const expandCategoryFilters = (values: readonly string[], availableCategories: readonly string[]): string[] => {
  const groups = new Map<string, string[]>();
  for (const category of normalizeCategoryFilters(availableCategories)) {
    const label = formatCategory(category);
    const group = groups.get(label);
    if (group) {
      group.push(category);
    } else {
      groups.set(label, [category]);
    }
  }

  return normalizeCategoryFilters(
    normalizeCategoryFilters(values).flatMap(category =>
      category === 'all' ? [category] : [...(groups.get(formatCategory(category)) || []), category],
    ),
  );
};
